import CloseIcon from "@mui/icons-material/Close";
export const Modal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center">
      <div className="bg-white p-3 rounded-lg shadow-lg w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">{title}</h3>
          
<button onClick={onClose} className="text-gray-500 hover:text-gray-700 h-5 w-5">
  <CloseIcon fontSize="small" />
</button>
        </div>
        {children}
      </div>
    </div>
  );
};
